import { useState, useEffect, useCallback } from 'react';
import footballService from '../services/footballService';

export const useLeagues = () => {
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeagues = async () => {
      setLoading(true);
      const result = await footballService.getLeagues();
      if (result.success) {
        setLeagues(result.data);
      } else {
        setError('Ligler yüklenirken bir hata oluştu');
      }
      setLoading(false);
    };
    fetchLeagues();
  }, []);

  return { leagues, loading, error };
};

export const useStandings = (leagueKey) => {
  const [standings, setStandings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStandings = useCallback(async () => {
    if (!leagueKey) return;
    
    setLoading(true);
    setError(null);
    
    const result = await footballService.getStandings(leagueKey);
    if (result.success) {
      setStandings(result.data);
    } else {
      setError('Puan durumu yüklenirken bir hata oluştu');
    }
    setLoading(false);
  }, [leagueKey]);

  useEffect(() => {
    fetchStandings();
  }, [fetchStandings]);

  return { standings, loading, error, refetch: fetchStandings };
};

export const useTopScorers = (leagueKey) => {
  const [topScorers, setTopScorers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTopScorers = useCallback(async () => {
    if (!leagueKey) return;
    
    setLoading(true);
    setError(null);
    
    const result = await footballService.getTopScorers(leagueKey);
    if (result.success) {
      setTopScorers(result.data);
    } else {
      setError('Gol kralları yüklenirken bir hata oluştu');
    }
    setLoading(false);
  }, [leagueKey]);

  useEffect(() => {
    fetchTopScorers();
  }, [fetchTopScorers]);

  return { topScorers, loading, error, refetch: fetchTopScorers };
};

export default useStandings;
